import * as React from "react";
import {Guid} from "guid-typescript";

import {ITopicPair, ITopicPairPublishStatus} from "../../~store/models/TopicPair";
import {ITopicPairItem, IQuestionItem, IAnswerItem, IParametersKeyValuePair} from "./~types/TopicPairItem";
import {TopicPairStatus} from "../../~store/models/enums/TopicPairStatus";
import {ITopicPairsItemProps} from "./~types/TopicPairsItemProps";
import {ITopicPairsItemState} from "./~types/TopicPairsItemState";
import { BUTTON_TYPES_WITH_FIXED_VALUE, DEFAULT_BUTTON_ROW_ID } from "./TopicPairItemConstants";

import {Button, Input, Label, ButtonGroup} from "reactstrap";
import ScalableTextInput from "../../../shared/components/scalable-text-input/ScalableTextInput";
import NlpAnswerTextInput from "../../../shared/components/nlp-answer-text-inpit/NlpAnswerTextInput"
import { stringToTopicPairContentType, TopicPairContentType, topicPairContentTypeToString } from "../../~store/models/enums/TopicPairContentType";

import "./TopicPairsItem.css";
import "src/app/setting/settings-main/settings-list/setting-item/SettingItem.css"
import { createNlpButton, INlpButton, NlpButtonType, nlpButtonTypeToString, INlpButtonRow } from "../../~store/models/Answer";
import { ModalWindow } from "src/app/shared/components/modal-window/ModalWindow";
import i18n from "src/app/shared/localization/i18n";
import SettingsItem from "src/app/setting/settings-main/settings-list/setting-item/SettingItem";
import { ISetting } from "src/app/setting/~store/models/setting";
import { canMoveNlpButtonToRow, getButtonRowIds, getButtonRows, getNlpButtonImage, changeNlpButtonPosition, moveNlpButtonToRow} from "./TopicPairItemHelper";

const MAX_NAME_LENGTH_EXCEEDED = 20;
const MAX_NAME_LENGTH = 400;

class TopicPairsItem extends React.Component<ITopicPairsItemProps, ITopicPairsItemState> {
    private _editingButtonNameValidationStarted: boolean = false;

    public readonly state: Readonly<ITopicPairsItemState> = {
        editedTopicPair: {} as ITopicPairItem,
        answerTextVariant: 1,
        currentAnswerText: "",
        editingButton: undefined,
        editingButtonName: undefined,
        editingButtonRowId: undefined,
        buttonRowIds: [],
        topicPairContentType: this.props.topicPairContentType
    };

    private inpRef: React.RefObject<ScalableTextInput | null>;

    constructor(props: ITopicPairsItemProps) {
        super(props);
        this.inpRef = React.createRef();
    }

    public componentWillMount() {
        this._setEditedItemByTopicPair(this.props.innerTopicPair);
    }

    public componentWillReceiveProps(nextProps: ITopicPairsItemProps) {
        this._setEditedItemByTopicPair(nextProps.innerTopicPair);
    }

    public componentDidMount() {
        this.setCurrentAnswerText();
        if (this.props.innerTopicPair.topicPairId === 0) {
            this.setState({
                editedTopicPair: {
                    ...this.state.editedTopicPair,
                    contentType: this.state.topicPairContentType
                }
            })
        }
    }

    public setCurrentAnswerText() {
        const {editedTopicPair} = this.state;
        const answer = this._getEditedTopicPairAnswer();
        const buttons = answer?.buttons;
        this.setState({editedTopicPair: {...editedTopicPair, answer: {...answer, buttons: buttons ? [...buttons] : answer.buttons}}, editingButtonName: undefined, editingButton: undefined})
        this.setState({currentAnswerText: editedTopicPair.answer ? (editedTopicPair.answer.edited_Text ?? editedTopicPair.answer.text) : ""}, () => {
            this.updateAnswerInput();});
    }

    public updateAnswerInput() {
        this.inpRef.current?.resize();
    }

    private gatItemClassName() {
        switch(this.state.editedTopicPair.publishStatus){
            case ITopicPairPublishStatus.Published:
                return "";
            case ITopicPairPublishStatus.Added:
                    return " item-added";
            case ITopicPairPublishStatus.Edited:
                return " item-edited";
            case ITopicPairPublishStatus.Removed:
                return " item-removed";
        }
    }

    isLengthExceeded(name: string) {
        return name.length > MAX_NAME_LENGTH_EXCEEDED;
    }

    public render() {
        const {editedTopicPair} = this.state;
        const isHasChanges = this._checkIfHasChanges();
        const isTopicPairInPendingStatus = editedTopicPair.status === TopicPairStatus.Pending;
        const questionContainerClassName = isTopicPairInPendingStatus ? "col s12" : "col s6";

        return (
            <section
                className={"topic-pairs-item" + this.gatItemClassName()}
                id={editedTopicPair.topicPairId.toString()}
                data-testid="topic-pair"
                data-pair-id={editedTopicPair?.topicPairId}
            >
                <div className="topic-pairs-item_main-content-wrapper">
                <div className="topic-pairs-item-header">
                    <div className="topic-pairs-item-header__content-grow topic-pairs-item-header__identifier">
                        <div className="topic-pairs-item-header__topic-pair-id">{editedTopicPair.topicPairId}</div>
                        {!isTopicPairInPendingStatus && (<div className="topic-pairs-item-header__trigger_name">
                                <Input
                                    onChange={this._onChangeTriggerNameHandler}
                                    onBlur={this._onBlurTriggerNameHandler}
                                    value={editedTopicPair.triggerName || ""}
                                    placeholder={i18n.t('nlp.triggerName')}
                                    data-testid="nlp-pair-trigger"
                                    type="text" className="input__trigger-name" />
                        </div>)}

                        {!isTopicPairInPendingStatus && <div className="topic-pairs-item-header__category">
                                <input
                                    value={editedTopicPair.category}
                                    onChange={this._onCategoryChanged}
                                    onBlur={this._onCategoryBlurred}
                                    placeholder={i18n.t('nlp.subject')}
                                    data-testid="nlp-pair-subject"
                                    type="text"
                                    list="categories" />
                            <datalist id="categories">
                                {this.props.topicPairCategories.map((item, index) => {
                                    return (
                                        <option key={index}>{item}</option>
                                    );
                                })}
                            </datalist>
                        </div>}

                    </div>
                    <div className="topic-pairs-item-header__content">
                        {this._getTopicPairContentTypeDropdown()}
                            {!isTopicPairInPendingStatus && (
                                <SettingsItem setting= { {value: JSON.stringify(this.props.innerTopicPair.answer?.parametersJson)} as ISetting }
                                    onSettingSave={(setting) => this._onSaveButtonClick(setting.value)}
                                    disabled={!this.props.innerTopicPair.topicPairId || isHasChanges && !isTopicPairInPendingStatus}
                        />
                            )}
                            
                        {isHasChanges && !isTopicPairInPendingStatus && (
                            <React.Fragment>
                                <Button
                                    className="topic-pairs-item__button topic-pairs-item__button-save"
                                    data-testid="nlp-pair-save"
                                    onClick={this._onSaveChangesHandler}
                                    disabled={!this._checkIfTopicPairIsValid()}>
                                    <i className="material-icons">save</i>
                                </Button>
                                <Button className="topic-pairs-item__button topic-pairs-item__button-discard" onClick={this._onDiscardChangesHandler}>
                                    <i className="material-icons">replay</i>
                                </Button>
                            </React.Fragment>
                        )}

                            {(!isHasChanges && !isTopicPairInPendingStatus) && (
                            <React.Fragment>
                                    {this._getChangeStatusButton()}
                                <Button className="topic-pairs-item__button topic-pairs-item__button-delete" onClick={this._onDeleteTopicPairHandler}>
                                    <i className="material-icons">delete_forever</i>
                                </Button>
                            </React.Fragment>
                        )}
                    </div>
                </div>
                <div className="topic-pairs-item-content row">
                    <div className={questionContainerClassName + " topic-pairs-item__question"}>
                        {!isTopicPairInPendingStatus && (
                            <Button className="topic-pairs-item__button-create" onClick={this._onCreateQuestionHandler}>
                                <i className="material-icons">add</i>
                            </Button>
                        )}
                        {this._getQuestionInputControls(isTopicPairInPendingStatus, this._checkIfQuestionsTransferable())}
                    </div>

                    {!isTopicPairInPendingStatus && (
                        <div className="col s6">
                            <div className="topic-pairs-item__variant-buttons">
                                <Button name = "variant-1" 
                                        onClick={this._onChangeAnswerTextVariantHandler}>
                                    <span className={this.state.answerTextVariant === 1 ? "topic-pairs-item__button-variant-answer_checked" : ""}>{i18n.t('common.answer') + ' 1'}</span> 
                                </Button>
                                <Button name = "variant-2"  
                                        onClick={this._onChangeAnswerTextVariantHandler}>
                                    <span className={this.state.answerTextVariant === 2 ? "topic-pairs-item__button-variant-answer_checked" : ""}>{i18n.t('common.answer') + ' 2'}</span> 
                                </Button>
                                <Button name = "variant-3" 
                                        onClick={this._onChangeAnswerTextVariantHandler}>
                                    <span className={this.state.answerTextVariant === 3 ? "topic-pairs-item__button-variant-answer_checked" : ""}>{i18n.t('common.answer') + ' 3'}</span>
                                </Button>
                            </div>
                            <NlpAnswerTextInput value={this.state.currentAnswerText} placeholder="No answer exists" onChange={this._onChangeAnswerTextHandler}/>
                                {this._getButtonsControl()}
                        </div>
                    )}
                </div>
                </div>
                {isTopicPairInPendingStatus && (
                    <div className="topic-pairs-item__pending">
                        <Label className="topic-pair-items__input">
                            <Input type={"checkbox"} onChange={(event) => this.props.isTopicPairChecked(event, editedTopicPair.topicPairId)} />
                            <span>
                                {""}
                            </span>
                        </Label>
                    </div>
                )}

                <ModalWindow 
                    className="add-button-dialog" 
                    isOpen={this.state.editingButton !== undefined} 
                    header={this._getEditingButtonHeader()} 
                    body={this._getEditingButtonBody()} 
                    footer={this._getEditingButtonFooter()}
                />
            </section>
        );
    }

    private _onChangeTriggerNameHandler = (event: React.FormEvent<HTMLInputElement>): void =>{
        const {editedTopicPair} = this.state;
        const triggerName = event.currentTarget.value;
        this.setState({editedTopicPair: {...editedTopicPair, triggerName}});
    }

    private _onBlurTriggerNameHandler = (event: React.FocusEvent<HTMLInputElement>): void => {
        const normalizedTriggerName = event.currentTarget.value.trim();
        this.setState(prev => ({
            editedTopicPair: {
                ...prev.editedTopicPair,
                triggerName: normalizedTriggerName
            }
        }));
    };

    private _onCategoryChanged = (event: React.FormEvent<HTMLInputElement>): void =>{
        const {editedTopicPair} = this.state;
        const category = event.currentTarget.value;
        this.setState({editedTopicPair: {...editedTopicPair, category}})
    }

    private _onCategoryBlurred = (event: React.FocusEvent<HTMLInputElement>): void => {
        const normalizedCategory = event.currentTarget.value.trim();
        this.setState(prev => ({
            editedTopicPair: {
                ...prev.editedTopicPair,
                category: normalizedCategory
            }
        }));
    };

    private _onChangeAnswerTextVariantHandler = (event: any): void =>{
        let answerTextVariant = 1;
        let currentAnswerText = "";
        switch (event.currentTarget.name)
        {
            case "variant-1":
                answerTextVariant = 1;
                currentAnswerText = this.state.editedTopicPair.answer ?
                    (this.state.editedTopicPair.answer.edited_Text ?? this.state.editedTopicPair.answer.text) :
                    "";
                break;
            case "variant-2":
                answerTextVariant = 2;
                currentAnswerText = this.state.editedTopicPair.answer ?
                    (this.state.editedTopicPair.answer.edited_AlternativeText1 ?? this.state.editedTopicPair.answer.alternativeText1) :
                    "";
                break;
            case "variant-3":
                answerTextVariant = 3;
                currentAnswerText = this.state.editedTopicPair.answer ?
                    (this.state.editedTopicPair.answer.edited_AlternativeText2 ?? this.state.editedTopicPair.answer.alternativeText2) :
                    "";
                break;
        }
        this.setState({answerTextVariant});
        this.setState({currentAnswerText: currentAnswerText ? currentAnswerText : ""}, () => {
            this.updateAnswerInput();});
    }

    private _onChangeTopicPairStatusHandler = (topicPairStatus: TopicPairStatus): void => {
            this.props.onChangeTopicPairStatus(this.props.innerTopicPair.topicPairId, topicPairStatus);
    };

    private _onDiscardChangesHandler = (): void => {
        this._setEditedItemByTopicPair(this.props.innerTopicPair);
    };

    private _onSaveChangesHandler = (): void => {
        const topicPair = this._buildTopicPair(this.state.editedTopicPair);
        this.props.onCommitTopicPairChanges(topicPair);
    };

    private _onDeleteTopicPairHandler = (): void => {
        const {editedTopicPair: { topicPairId }} = this.state;
        this.props.onDeleteTopicPair(topicPairId);
    };

    private _onTransferQuestionHandler = (questionId: number): void => {
        this.props.onTransferTopicPairQuestion(this.state.editedTopicPair.topicPairId, questionId);
    };

    private _onChangeAnswerTextHandler = (event?: string): void => {
        const {editedTopicPair} = this.state;
        const newAnswerText = event ?? "";
        const answer = this._getEditedTopicPairAnswer();
        switch(this.state.answerTextVariant)
        {
            case 1:
                this.setState({editedTopicPair: {...editedTopicPair, answer: {...answer, edited_Text: newAnswerText}}});
                break;
            case 2:
                this.setState({editedTopicPair: {...editedTopicPair, answer: {...answer, edited_AlternativeText1 : newAnswerText}}});
                break;
            case 3:
                this.setState({editedTopicPair: {...editedTopicPair, answer: {...answer, edited_AlternativeText2 : newAnswerText}}});
                break;
            default:
                return;
        }
        this.setState({currentAnswerText: newAnswerText ? newAnswerText : ""});
    };

    private _getEditedTopicPairAnswer = (): IAnswerItem => {
        return this.state.editedTopicPair.answer ? this.state.editedTopicPair.answer :
            {
                answerId: 0, text: "", alternativeText1: "", alternativeText2: "",
                edited_Text: null, edited_AlternativeText1: null, edited_AlternativeText2: null, buttons: [], parametersJson: {}
            };
    }

    private _onChangeQuestionTextHandler = (event: React.FormEvent<HTMLInputElement>, questionGuid: string): void => {
        const {editedTopicPair} = this.state;
        const question = editedTopicPair.questions.find(q => q.questionGuid === questionGuid);
        const newQuestionText = event.currentTarget.value;
        const updatedQuestions = [...editedTopicPair.questions.filter(q => q.questionGuid !== questionGuid), {...question!, text: newQuestionText}];

        this.setState({editedTopicPair: {...editedTopicPair, questions: updatedQuestions}});
    };

    private _onQuestionTextBlurred = (event: React.FocusEvent<HTMLInputElement>, questionGuid: string) : void => {
        const normalizedText = event.currentTarget.value.trim();
        const { editedTopicPair } = this.state;
        const question = editedTopicPair.questions.find(q => q.questionGuid === questionGuid);
        const updatedQuestions = [...editedTopicPair.questions.filter(q => q.questionGuid !== questionGuid), { ...question!, text: normalizedText }];

        this.setState({editedTopicPair: { ...editedTopicPair, questions: updatedQuestions }});
    };


    private _onChangeDefaultQuestionHandler = (event: React.FormEvent<HTMLInputElement>, questionGuid: string): void => {
        const {editedTopicPair} = this.state;
        const question = editedTopicPair.questions.find(q => q.questionGuid === questionGuid);
        const updatedQuestions = [
            ...editedTopicPair.questions.filter(q => q.questionGuid !== questionGuid).map(q => ({...q, isDefault: false})),
            {...question!, isDefault: true}
        ];

        this.setState({editedTopicPair: {...editedTopicPair, questions: updatedQuestions}});
    };

    private _onCreateQuestionHandler = (): void => {
        const {editedTopicPair} = this.state;
        const isNoQuestionsExist = editedTopicPair.questions.length === 0;

        const newQuestion = {
            text: "",
            isDefault: isNoQuestionsExist,
            questionId: 0,
            questionGuid: Guid.create().toString(),
            questionIndex: 0
        };

        const questions = editedTopicPair.questions.map(q => ({...q, questionIndex: ++q.questionIndex}));

        this.setState({editedTopicPair: {...editedTopicPair, questions: [...questions, newQuestion]}});
    };

    private _onDeleteQuestionHandler = (questionGuid: string): void => {
        const { editedTopicPair } = this.state;
        const deletedQuestion = editedTopicPair.questions.find(q => q.questionGuid == questionGuid);
        const questions = editedTopicPair.questions.filter(q => q.questionGuid !== questionGuid);
        if (questions.length > 0 && deletedQuestion?.isDefault)
            questions[0].isDefault = true;
        this.setState({editedTopicPair: {...editedTopicPair, questions: [...questions]}});
    };

    private _onNlpButtonDelete = (button: INlpButton, rowId: number): void => {
        if (!window.confirm(i18n.t('nlp.sureRemoveButton') + button.name + "?")) {
            return;
        }

        const answer = this._getEditedTopicPairAnswer();
        const buttons = answer.buttons.filter(item => {
            const itemRowId = item.rowId ?? DEFAULT_BUTTON_ROW_ID;
            return !(
                item.name === button.name &&
                itemRowId === rowId
            );
        });

        this.setState({editedTopicPair: {...this.state.editedTopicPair, answer: {...answer, buttons }}});
    }

    private _getChangeStatusButton = (): React.ReactElement<{}> => {
        const {editedTopicPair} = this.state;
        switch (editedTopicPair.status) {
            case TopicPairStatus.Active:
                return (
                    <Button
                        className="topic-pairs-item__button topic-pairs-item__button-inactive"
                        onClick={() => this._onChangeTopicPairStatusHandler(TopicPairStatus.Inactive)}>
                        <i className="material-icons">remove</i>
                    </Button>
                );
            case TopicPairStatus.Inactive:
                return (
                    <Button
                        className="topic-pairs-item__button topic-pairs-item__button-active"
                        onClick={() => this._onChangeTopicPairStatusHandler(TopicPairStatus.Active)}>
                        <i className="material-icons">add</i>
                    </Button>
                );
            case TopicPairStatus.Pending:
                return (
                    <Button
                        className="topic-pairs-item__button topic-pairs-item__button-pending"
                        onClick={() => this._onChangeTopicPairStatusHandler(TopicPairStatus.Inactive)}>
                        <i className="material-icons">check</i>
                    </Button>
                );
            default:
                return this._getErrorControl();
        }
    };

    private _getQuestionInputControls = (isTopicPairInPendingStatus: boolean, areTransferable: boolean): Array<React.ReactElement<{}>> => {
        return this.state.editedTopicPair.questions
            .sort((q1, q2) => q1.questionIndex - q2.questionIndex)
            .map(q => this._getQuestionInputControl(q, isTopicPairInPendingStatus, areTransferable));
    };

    private _getQuestionInputControl = (question: IQuestionItem, isTopicPairInPendingStatus: boolean, isTransferable: boolean): React.ReactElement<{}> => {
        var isEditableText = this.state.editedTopicPair.status === TopicPairStatus.Pending;
        return (
            <div key={question.questionGuid} className="topic-pairs-item__question-container">
                <Label className="topic-pairs-item__question-editor" data-testid="nlp-pair-question" check={true}>
                    <Input
                        type="radio"
                        name={question.questionGuid}
                        checked={question.isDefault}
                        onChange={event => this._onChangeDefaultQuestionHandler(event, question.questionGuid)}
                    />
                    <span>{""}</span>
                    <ScalableTextInput
                        value={question.text}
                        onKeyDown={event => event.keyCode == 13 ? this._onCreateQuestionHandler() : ""}
                        onChange={event => this._onChangeQuestionTextHandler(event, question.questionGuid)}
                        onBlur={event => this._onQuestionTextBlurred(event, question.questionGuid)}
                        readonly={isEditableText} />
                </Label>

                {!isTopicPairInPendingStatus && (
                    <React.Fragment>
                        <ButtonGroup className="topic-pairs-item__question-buttons">
                            {isTransferable && (
                                <Button className="topic-pairs-item__button topic-pairs-item__button-move" onClick={() => this._onTransferQuestionHandler(question.questionId)}>
                                    <i className="material-icons">arrow_forward</i>
                                </Button>
                            )}

                            <Button className="topic-pairs-item__button topic-pairs-item__button-delete" onClick={() => this._onDeleteQuestionHandler(question.questionGuid)}>
                                <i className="material-icons">clear</i>
                            </Button>
                        </ButtonGroup>
                    </React.Fragment>
                )}
            </div>
        );
    };

    private _mapButtonRows = (rows: INlpButtonRow[]): React.ReactElement<{}> => {
        return (
            <div className="nlp-buttons-container">
                {rows.map((row, rowIndex) => {
                    return (
                        <div key={row.id} className="nlp-button-row-container" data-testid="nlp-button-row" data-row-id={row.id}>
                            <div className="nlp-button-row-header">
                                <span className="nlp-button-row-title"> {i18n.t('nlp.buttonRow')} {rowIndex + 1}</span>
                                {rows.length > 1 && (
                                    <Button
                                        className="topic-pairs-item__button topic-pairs-item__button-delete"
                                        data-testid="nlp-button-row-delete"
                                        onClick={() => this._onDeleteButtonRow(row.id)}
                                    >
                                        <i className="material-icons">delete</i>
                                    </Button>
                                )}
                            </div>
                            <div className="nlp-button-row-buttons">
                                {row.buttons.map(button => this._renderNlpButton(button, row.id))}
                                <img src={require("./../../../shared/images/add.png")} alt="Add button" title={"Add button"} className={"add-nlp-button"} data-testid="nlp-button-add" onClick={() => { this._onAddButtonToRow(row.id); }} />
                            </div>
                        </div>
                    );
                })}
                <Button className="topic-pairs-item__button nlp-button-add-row" data-testid="nlp-button-row-add" onClick={this._onAddButtonRow}>
                    <i className="material-icons">add</i>
                    <span> {i18n.t('nlp.addButtonRow')} </span>
                </Button>
            </div>
        );
    };

    private _mapButtons = (buttons: INlpButton[] | undefined): React.ReactElement<{}> => {
        return (
            <div className="nlp-buttons-container">
                {buttons && buttons.map(item =>
                    <div key={item.name + item.value} className="nlp-button-line">
                        <span> <img onClick={() => { this._changeNlpButtonPosition(item.name, DEFAULT_BUTTON_ROW_ID, false); }} src={require("./../../../shared/images/arrow.png")} className="nlp-button-img-change-pos" title="Вниз" /></span>
                        <span><img onClick={() => { this._changeNlpButtonPosition(item.name, DEFAULT_BUTTON_ROW_ID, true); }} src={require("./../../../shared/images/arrow.png")} className="nlp-button-img-change-pos change-pos-up" title="Вверх" /></span>
                        <span className="nlp-button" title={item.value}>
                            <img src={getNlpButtonImage(item.type)} className="nlp-button-img" title={NlpButtonType[item.type]} />
                            <span className="nlp-button__name"> {item.name}</span>
                            {this.isLengthExceeded(item.name) && (<span className="warning-icon" data-testid="nlp-button-length-warning" title={i18n.t('nlp.exceededLimitButton')}> &#x26A0;</span>)}
                        </span>
                        <span className="nlp-buttons-management">
                            <span data-testid="nlp-button-edit" onClick={() => { this._editingButtonNameValidationStarted = false; this.setState({ editingButton: { ...item }, editingButtonName: item.name, editingButtonRowId: DEFAULT_BUTTON_ROW_ID})}}>{i18n.t('nlp.nlpButtonEdit')}</span>
                            <span data-testid="nlp-button-delete" onClick={() => { this._onNlpButtonDelete(item, DEFAULT_BUTTON_ROW_ID)}}>{i18n.t('nlp.nlpButtonDelete')}</span>
                        </span>
                    </div>
                ) }
                <div>
                    <img src={require("./../../../shared/images/add.png")} alt="Add button" title="Add button" className="add-nlp-button" data-testid="nlp-button-add" onClick={() => { this._editingButtonNameValidationStarted = false; this._onAddButtonToRow(DEFAULT_BUTTON_ROW_ID) }} />
                </div>
                {!!buttons && buttons.length > 0 && (
                    <Button className="topic-pairs-item__button nlp-button-add-row" data-testid="nlp-button-row-add" onClick={this._onAddButtonRow}>
                        <i className="material-icons">add</i>
                        <span>{i18n.t("nlp.addButtonRow")}</span>
                    </Button>
                )}
            </div>
        );
    }

    private _renderNlpButton = (item: INlpButton, rowId: number): React.ReactElement<{}> => {
        const buttons = this.state.editedTopicPair.answer ? this.state.editedTopicPair.answer.buttons : [];
        const canMoveToPreviousRow = canMoveNlpButtonToRow(rowId, -1, buttons, this.state.buttonRowIds);
        const canMoveToNextRow = canMoveNlpButtonToRow(rowId, 1, buttons, this.state.buttonRowIds);
        return (
            <div key={item.name + item.value} className="nlp-button-row-item" data-testid="nlp-button">
                <div className="nlp-button-row-item__vertical-controls">
                    <img
                        src={require("./../../../shared/images/arrow.png")}
                        className={"nlp-button-row-item__arrow " + "nlp-button-row-item__arrow_up " + (!canMoveToPreviousRow ? "nlp-button-row-item__arrow_disabled" : "")}
                        title={canMoveToPreviousRow ? "Перенести в строку выше" : "Нет строки выше"}
                        data-testid="nlp-button-move-up"
                        onClick={() => {
                            if (canMoveToPreviousRow) {
                                this._moveNlpButtonToAdjacentRow(item, rowId, -1);
                            }
                        }}
                    />
                    <img
                        src={require("./../../../shared/images/arrow.png")}
                        className={"nlp-button-row-item__arrow " + "nlp-button-row-item__arrow_down " + (!canMoveToNextRow ? "nlp-button-row-item__arrow_disabled" : "")}
                        title={canMoveToNextRow ? "Перенести в строку ниже" : "Нет строки ниже"}
                        data-testid="nlp-button-move-down"
                        onClick={() => {
                            if (canMoveToNextRow) {
                                this._moveNlpButtonToAdjacentRow(item, rowId, 1);
                            }
                        }}
                    />
                </div>
                <div className="nlp-button-row-item__main">
                    <div className="nlp-button-row-item__horizontal-controls">
                        <img
                            src={require("./../../../shared/images/arrow.png")}
                            className={"nlp-button-row-item__arrow " + "nlp-button-row-item__arrow_left"}
                            title="Передвинуть влево"
                            data-testid="nlp-button-move-left"
                            onClick={() => this._changeNlpButtonPosition(item.name, rowId, true)}
                        />
                        <img
                            src={require("./../../../shared/images/arrow.png")}
                            className={"nlp-button-row-item__arrow " + "nlp-button-row-item__arrow_right"}
                            title="Передвинуть вправо"
                            data-testid="nlp-button-move-right"
                            onClick={() => this._changeNlpButtonPosition(item.name, rowId, false)}
                        />
                    </div>
                    <div className="nlp-button nlp-button_row-layout" title={item.value}>
                        <img src={getNlpButtonImage(item.type)} className="nlp-button-img" title={NlpButtonType[item.type]} />
                        <span className="nlp-button__name"> {item.name} </span>
                        {this.isLengthExceeded(item.name) && (<span className="warning-icon" data-testid="nlp-button-length-warning" title={i18n.t('nlp.exceededLimitButton')}>&#x26A0;</span>)}
                    </div>
                </div>
                <div className="nlp-button-row-item__actions">
                    <i
                        className={"material-icons nlp-button-row-item__action"}
                        title={i18n.t('nlp.nlpButtonEdit')}
                        data-testid="nlp-button-edit"
                        onClick={() => this.setState({ editingButton: { ...item }, editingButtonName: item.name, editingButtonRowId: rowId })}
                    >
                        edit
                    </i>
                    <i
                        className={"material-icons " + "nlp-button-row-item__action " + "nlp-button-row-item__action_delete"}
                        title={i18n.t('nlp.nlpButtonDelete')}
                        data-testid="nlp-button-delete"
                        onClick={() => this._onNlpButtonDelete(item, rowId)}
                    >
                        delete
                    </i>
                </div>
            </div>
        );
    };

    private _getTopicPairContentTypeDropdown = (): React.JSX.Element => {
        if (!(this.state.editedTopicPair.status === TopicPairStatus.Pending))
            return (
                <Input
                    type="select"
                    className="topic-pair-content-type__input"
                    data-testid="nlp-pair-content-type"
                    value={topicPairContentTypeToString(this.state.editedTopicPair.contentType)}
                    onChange={(event) => { this._changeTopicPairContentType(stringToTopicPairContentType(event.target.value)) }} >
                    <option>{topicPairContentTypeToString(TopicPairContentType.Markup)}</option>
                    <option>{topicPairContentTypeToString(TopicPairContentType.Text)}</option>
                    <option>{topicPairContentTypeToString(TopicPairContentType.Video)}</option>
                    <option>{topicPairContentTypeToString(TopicPairContentType.Audio)}</option>
                    <option>{topicPairContentTypeToString(TopicPairContentType.Navigation)}</option>
                    <option>{topicPairContentTypeToString(TopicPairContentType.TextToSpeech)}</option>
                    <option>{topicPairContentTypeToString(TopicPairContentType.Iframe)}</option>
                </Input>
            );
        else
            return(<></>)
    }

    private _changeTopicPairContentType = (contentType: TopicPairContentType): void => {
        this.setState({
            editedTopicPair: {
                ...this.state.editedTopicPair,
                contentType: contentType
            }
        })
    }

    private _changeNlpButtonPosition = (buttonName: string, rowId: number, isUpDirection: boolean): void => {
        const answer = this._getEditedTopicPairAnswer();
        const updatedButtons = changeNlpButtonPosition(answer.buttons, buttonName, rowId, isUpDirection);

        this.setState({
            editedTopicPair: {
                ...this.state.editedTopicPair,
                answer: {
                    ...answer,
                    buttons: updatedButtons
                }
            }
        });
    };

    private _getEditingButtonHeader = (): React.ReactElement<{}> => {
        return (
            <>
                <div>
                    {this.state.editingButtonName === undefined
                        ? i18n.t("nlp.newButton")
                        : i18n.t("nlp.buttonEditing")}
                </div>
                <Button
                    className="red"
                    data-testid="nlp-button-dialog-close"
                    onClick={() => {
                        this.setState({
                            editingButtonName: undefined,
                            editingButton: undefined,
                            editingButtonRowId: undefined
                        });
                    }}
                >
                    <i className="material-icons">close</i>
                </Button>
            </>
        );
    }

    private _getEditingButtonBody = (): React.ReactElement<{}> => {
        if (this.state.editingButton === undefined) return <></>;

        const isTooLong = this.isLengthExceeded(this.state.editingButton?.name);
        const showEmptyError = this._editingButtonNameValidationStarted && this.state.editingButton?.name.trim() === "";

        return (
            <div className="edit-nlp-button-dialog-container">
                <div>
                    <label>{i18n.t('nlp.buttonType')}</label> 
                    <span>
                        <Input
                            type="select"
                            className="dialog-nlp-button-type"
                            data-testid="nlp-button-type"
                            value={NlpButtonType[this.state.editingButton.type]}
                            onChange={this._onNlpButtonTypeChangeHandler}>
                            <option value={NlpButtonType[NlpButtonType.Trigger]}>{nlpButtonTypeToString(NlpButtonType.Trigger)}</option>
                            <option value={NlpButtonType[NlpButtonType.Text]}>{nlpButtonTypeToString(NlpButtonType.Text)}</option>
                            <option value={NlpButtonType[NlpButtonType.Link]}>{nlpButtonTypeToString(NlpButtonType.Link)}</option>
                            <option value={NlpButtonType[NlpButtonType.CustomEvent]}>{nlpButtonTypeToString(NlpButtonType.CustomEvent)}</option>
                            <option value={NlpButtonType[NlpButtonType.Back]}>{nlpButtonTypeToString(NlpButtonType.Back)}</option>
                            <option value={NlpButtonType[NlpButtonType.RequestContact]}>{nlpButtonTypeToString(NlpButtonType.RequestContact)}</option>
                            <option value={NlpButtonType[NlpButtonType.RequestGeolocation]}>{nlpButtonTypeToString(NlpButtonType.RequestGeolocation)}</option>
                        </Input>
                    </span>
                </div>
                <div>
                    <label>{i18n.t('nlp.text')}</label>
                    <div className="input-area">
                        <span className="input-wrapper">
                            <input type="text" data-testid="nlp-button-name" value={this.state.editingButton?.name ?? ""} onChange={this._onNlpButtonNameChangeHandler} className={showEmptyError ? "nlp-input nlp-input--invalid" : "nlp-input"} />
                            {isTooLong && (<span className="warning-icon" title={i18n.t('nlp.exceededLimitButton')}>&#x26A0;</span>)}
                        </span>
                        {showEmptyError && (<div className="nlp-input-error-text"> {i18n.t('nlp.emptyButtonNameTooltipMessage')} </div>)}
                    </div>
                </div>
                <div><label>{i18n.t('nlp.value')}</label> <span><input type="text" data-testid="nlp-button-value" value={this.state.editingButton?.value} disabled={BUTTON_TYPES_WITH_FIXED_VALUE.includes(this.state.editingButton?.type)} onChange={this._onNlpButtonValueChangeHandler}/></span></div>
                </div>
        )
    }

    private _getEditingButtonFooter = (): React.ReactElement<{}> => {
        return (
            <div>
                <Button data-testid="nlp-button-save" onClick={this._saveEditingButton}>
                    {i18n.t('common.save')}
                </Button>
            </div>
        );
    }

    private _saveEditingButton = (): void => {
        const { editedTopicPair, editingButton, editingButtonName, editingButtonRowId} = this.state;

        this._editingButtonNameValidationStarted = true;

        if (editingButton === undefined || editingButtonRowId === undefined || editingButton.name.trim().length === 0) {
            this.setState({});
            return;
        }

        const answer = this._getEditedTopicPairAnswer();
        const buttons = [...(answer.buttons || [])];

        const isDuplicate = buttons.some(button => {
            const buttonRowId = button.rowId ?? DEFAULT_BUTTON_ROW_ID;
            const isCurrentButton = editingButtonName !== undefined && button.name === editingButtonName && buttonRowId === editingButtonRowId;

            return !isCurrentButton && button.name === editingButton.name;
        });

        if (isDuplicate) {
            alert(i18n.t('nlp.buttonTextExists'));
            return;
        }

        const buttonIndex = editingButtonName === undefined
            ? -1
            : buttons.findIndex(button => button.name === editingButtonName &&
                (button.rowId ?? DEFAULT_BUTTON_ROW_ID) === editingButtonRowId
            );

        const buttonToSave: INlpButton = editingButtonRowId === DEFAULT_BUTTON_ROW_ID
            ? { type: editingButton.type, name: editingButton.name, value: editingButton.value }
            : { ...editingButton, rowId: editingButtonRowId};

        if (buttonIndex >= 0) {
            buttons[buttonIndex] = buttonToSave;
        } else {
            buttons.push(buttonToSave);
        }

        this.setState({
            editedTopicPair: {
                ...editedTopicPair,
                answer: {
                    ...answer,
                    buttons
                }
            },
            editingButton: undefined,
            editingButtonName: undefined,
            editingButtonRowId: undefined
        });
    };

    private _onNlpButtonTypeChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const type = NlpButtonType[event.currentTarget.value as keyof typeof NlpButtonType];
        const eb = this.state.editingButton ?? createNlpButton();
        this.setState({editingButton: {...eb, type}});
    }

    private _onNlpButtonNameChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.currentTarget.value.length <= MAX_NAME_LENGTH) {
            const name = event.currentTarget.value;
            const eb = this.state.editingButton ?? createNlpButton();

            if (eb?.type === NlpButtonType.Text)
                this.setState({ editingButton: { ...eb, name, value: name } });
            else
                this.setState({ editingButton: { ...eb, name} });
        }
    }

    private _onNlpButtonValueChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.currentTarget.value;
        const eb = this.state.editingButton ?? createNlpButton();
        this.setState({editingButton: {...eb, value}});
    }

    private _getErrorControl = (): React.ReactElement<{}> => {
        return <div>{i18n.t('nlp.noFoundTopicPair')}</div>;
    };

    private _setEditedItemByTopicPair = (innerTopicPair: ITopicPair): void => {
        const buttons = innerTopicPair.answer?.buttons || [];
        const rowIds = Array.from(
            new Set(
                buttons
                    .map(button => button.rowId)
                    .filter((rowId): rowId is number =>
                        rowId !== undefined &&
                        rowId !== null &&
                        rowId > DEFAULT_BUTTON_ROW_ID
                    )
            )
        ).sort((a, b) => a - b);

        this.setState({
            editedTopicPair: this._buildTopicPairItem(innerTopicPair),
            currentAnswerText: innerTopicPair.answer?.edited_Text ?? innerTopicPair.answer?.text ?? "",
            answerTextVariant: 1,
            buttonRowIds: rowIds,
            editingButton: undefined,
            editingButtonName: undefined,
            editingButtonRowId: undefined
        });
    };

    private _checkIfHasChanges = (): boolean => {
        const { innerTopicPair } = this.props;
        const { editedTopicPair } = this.state;

        return (
            innerTopicPair.topicPairId === 0 ||
            (editedTopicPair.answer && editedTopicPair.answer.answerId === 0) ||
            (innerTopicPair.triggerName !== editedTopicPair.triggerName) ||
            (innerTopicPair.subject !== editedTopicPair.category) ||
            (innerTopicPair.answer && editedTopicPair.answer && (innerTopicPair.answer.text !== editedTopicPair.answer!.text) ||
                (innerTopicPair.answer?.alternativeText1 !== editedTopicPair.answer?.alternativeText1) ||
                (innerTopicPair.answer?.alternativeText2 !== editedTopicPair.answer?.alternativeText2) ||
                (innerTopicPair.answer?.edited_Text !== editedTopicPair.answer?.edited_Text) ||
                (innerTopicPair.answer?.edited_AlternativeText1 !== editedTopicPair.answer?.edited_AlternativeText1) ||
                (innerTopicPair.answer?.edited_AlternativeText2 !== editedTopicPair.answer?.edited_AlternativeText2)) ||
            editedTopicPair.questions.some(q => q.questionId === 0) ||
            editedTopicPair.questions.length !== innerTopicPair.questions.length ||
            innerTopicPair.questions.some(iq =>
                editedTopicPair.questions.some(q => q.questionId === iq.questionId && (q.text !== iq.text || q.isDefault !== iq.isDefault))) ||
            this._checkIfButtonsChanged(innerTopicPair.answer?.buttons, editedTopicPair.answer?.buttons) ||
            innerTopicPair.contentType !== editedTopicPair.contentType
        );

    };

    private _checkIfButtonsChanged = (innerTopicPairButtons: INlpButton[] | undefined, editedTopicPairButtons: INlpButton[] | undefined): boolean => {
        if (innerTopicPairButtons && editedTopicPairButtons) {
            const a = JSON.stringify(innerTopicPairButtons);
            const b = JSON.stringify(editedTopicPairButtons);
            return  a !== b;
        }
        return false;
    }

    private _checkIfTopicPairIsValid = (): boolean => {
        const hasAnyQuestions = this.state.editedTopicPair.questions.length != 0;
        const hasNotEmptyQuestions = hasAnyQuestions && this.state.editedTopicPair.questions.every(q => q.text.trim().length > 0);
        const hasTrigger = this.state.editedTopicPair.triggerName !== null && this.state.editedTopicPair.triggerName?.length != 0;
        const hasAnswer = (!!this.state.editedTopicPair.answer?.edited_Text && this.state.editedTopicPair.answer.edited_Text.length != 0) ||
            (!!this.state.editedTopicPair.answer?.edited_AlternativeText1 && this.state.editedTopicPair.answer.edited_AlternativeText1.length != 0) ||
            (!!this.state.editedTopicPair.answer?.edited_AlternativeText2 && this.state.editedTopicPair.answer.edited_AlternativeText2.length != 0) ||
            (!!this.state.currentAnswerText && this.state.currentAnswerText.length != 0);
        
        const isValid = (hasNotEmptyQuestions && (hasTrigger || hasAnswer)) || (hasTrigger && !hasAnyQuestions);
        
        return isValid;
    }

    private _checkIfQuestionsTransferable = (): boolean => {
        const hasTrigger = this.state.editedTopicPair.triggerName !== null && this.state.editedTopicPair.triggerName?.length != 0;
        const hasCategory = this.state.editedTopicPair.category !== null && this.state.editedTopicPair.category?.length != 0;
        const hasMoreThanOneQuestion = this.state.editedTopicPair.questions?.length > 1;
        
        return !this._checkIfHasChanges() && (hasMoreThanOneQuestion || hasTrigger || hasCategory);
    }

    private _buildTopicPairItem = (topicPair: ITopicPair): ITopicPairItem => {
        return {
            topicPairId: topicPair.topicPairId,
            triggerName: topicPair.triggerName,
            status: topicPair.status,
            category: topicPair.subject,
            source: topicPair.source,
            answer: topicPair.answer,
            publishStatus: topicPair.publishStatus,
            questions: topicPair.questions.map((q, index) => ({
                text: q.text,
                isDefault: q.isDefault,
                questionId: q.questionId,
                questionGuid: Guid.create().toString(),
                questionIndex: index
            })),
            contentType: topicPair.contentType
        };
    };

    private _buildTopicPair = (topicPairItem: ITopicPairItem): ITopicPair => {      
        return {
            topicPairId: topicPairItem.topicPairId,
            triggerName: topicPairItem.triggerName,
            status: topicPairItem.status,
            answer: topicPairItem.answer,
            publishStatus: topicPairItem.publishStatus,
            subject: topicPairItem.category,
            source: topicPairItem.source,
            questions: topicPairItem.questions.map(q => ({
                text: q.text,
                isDefault: q.isDefault,
                questionId: q.questionId
            })),
            contentType: topicPairItem.contentType
        };
    };

    private _onSaveButtonClick = (settings: string) => {
        const answer = this._getEditedTopicPairAnswer();
        const {editedTopicPair} = this.state;

        this.setState({editedTopicPair: {...editedTopicPair, answer: {...answer, parametersJson: JSON.parse(settings)}}},
                () => this._onSaveChangesHandler());
    }

    private _onAddButtonRow = (): void => {
        this.setState(prevState => {
            const nextRowId = prevState.buttonRowIds.length === 0
                ? 1
                : Math.max(...prevState.buttonRowIds) + 1;

            return {
                buttonRowIds: [
                    ...prevState.buttonRowIds,
                    nextRowId
                ]
            };
        });
    };

    private _onDeleteButtonRow = (rowId: number): void => {
        this.setState(prevState => {
            const answer = prevState.editedTopicPair.answer;
            if (!answer)
                return null;

            const rows = getButtonRows(answer.buttons, prevState.buttonRowIds);
            if (rows.findIndex(row => row.id === rowId) === -1 || rows.length === 1)
                return null;

            const deletedRow = rows[rows.findIndex(row => row.id === rowId)];
            const remainingRows = rows.filter(row => row.id !== rowId);
            const targetRow = rowId === DEFAULT_BUTTON_ROW_ID
                ? remainingRows[0]
                : remainingRows.filter(row => row.id < rowId).sort((first, second) => second.id - first.id)[0];
            if (!targetRow)
                return null;

            targetRow.buttons.push(...deletedRow.buttons);

            const sortedRows = remainingRows.sort((first, second) => first.id - second.id);
            const buttons = sortedRows.length === 1
                ? sortedRows[0].buttons.map(button => ({ type: button.type, name: button.name, value: button.value }))
                : sortedRows.flatMap(row => row.buttons.map(button => ({ ...button, rowId: row.id })));

            return {
                editedTopicPair: {
                    ...prevState.editedTopicPair,
                    answer: {
                        ...answer,
                        buttons
                    }
                },
                buttonRowIds: sortedRows.length === 1
                    ? []
                    : sortedRows.filter(row => row.id !== DEFAULT_BUTTON_ROW_ID).map(row => row.id)
            };
        });
    };

    private _onAddButtonToRow = (rowId: number): void => {
        this.setState({
            editingButton: createNlpButton(),
            editingButtonName: undefined,
            editingButtonRowId: rowId
        });
    }

    private _getButtonsControl = (): React.ReactElement<{}> => {
        const buttons = this.state.editedTopicPair.answer?.buttons;
        return this.state.buttonRowIds.length > 0
            ? this._mapButtonRows(getButtonRows(buttons, this.state.buttonRowIds))
            : this._mapButtons(buttons);
    };

    private _moveNlpButtonToAdjacentRow = (item: INlpButton, rowId: number, offset: number): void => {
        const buttons = this.state.editedTopicPair.answer ? this.state.editedTopicPair.answer.buttons: [];
        const rowIds = getButtonRowIds(buttons, this.state.buttonRowIds);
        const currentRowIndex = rowIds.indexOf(rowId);
        const targetRowIndex = currentRowIndex + offset;

        if (currentRowIndex === -1 || targetRowIndex < 0 || targetRowIndex >= rowIds.length) return;

        this._moveNlpButtonToRow(item, rowId, rowIds[targetRowIndex]);
    };

    private _moveNlpButtonToRow = (item: INlpButton, sourceRowId: number, targetRowId: number): void => {
        const answer = this._getEditedTopicPairAnswer();
        const buttons = moveNlpButtonToRow(answer.buttons, item, sourceRowId, targetRowId);
        if (!buttons) {
            return;
        }

        this.setState(prevState => ({
            editedTopicPair: {
                ...prevState.editedTopicPair,
                answer: {
                    ...answer,
                    buttons
                }
            }
        }));
    };
}

export default TopicPairsItem;
